'use strict';
const url = require('url');
const prependHttp = require('prepend-http');

module.exports = (input, options) => {
	if (typeof input !== 'string') {
		throw new TypeError(`Expected \`url\` to be of type \`string\`, got \`${typeof input}\` instead.`);
	}

	const finalUrl = prependHttp(input, Object.assign({https: true}, options));
	return url.parse(finalUrl);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/url-parse-lax/index.js
// module id = ../node_modules/url-parse-lax/index.js
// module chunks = 5